import { Route } from 'react-router-dom';
import RegisterNewMember from '../forms/RegisterNewMember';
import ThankYouPage from '../forms/ThankYouPage';

const NoAuthRoutes = () => {
  return (
    <>
      <Route exact path="/" component={RegisterNewMember} />
      <Route exact path="/thank-you" component={ThankYouPage} />
    </>
  );
};

export default NoAuthRoutes;